var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#205493",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "18px",
    viewBox: "0 0 472.001 472.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.313,81.376H40.688C18.252,81.376,0,99.628,0,122.063v227.875c0,22.436,18.252,40.688,40.688,40.688h390.625 c22.436,0,40.688-18.252,40.688-40.688V122.063C472.001,99.627,453.749,81.376,431.313,81.376z M40.688,93.376h390.625 c15.817,0,28.688,12.869,28.688,28.687v25.734h-448v-25.734C12.001,106.245,24.87,93.376,40.688,93.376z M431.313,378.625H40.688 C24.87,378.625,12,365.756,12,349.938V176.796h448v173.142C460.001,365.756,447.132,378.625,431.313,378.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.369,243.591H73.344C60.472,243.591,50,254.063,50,266.935v27.75c0,12.871,10.472,23.344,23.344,23.344h70.025 c12.872,0,23.344-10.473,23.344-23.344v-27.75C166.713,254.063,156.241,243.591,143.369,243.591z M154.713,294.685 c0,6.254-5.089,11.344-11.344,11.344H73.344c-6.255,0-11.344-5.09-11.344-11.344v-27.75c0-6.254,5.089-11.344,11.344-11.344 h70.025c6.255,0,11.344,5.09,11.344,11.344V294.685L154.713,294.685z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.456,243.591H222.195c-3.313,0-6,2.688-6,6s2.687,6,6,6h195.261c3.312,0,6-2.688,6-6S420.771,243.591,417.456,243.591 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.995,290.418h-93.8c-3.313,0-6,2.687-6,6s2.687,6,6,6h93.8c3.312,0,6-2.687,6-6S319.309,290.418,315.995,290.418z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCardIcon);
export default __webpack_public_path__ + "static/media/bankCardIcon.53d9bbccb57660bf5288b349968c8b99.svg";
export { ForwardRef as ReactComponent };